import React, { createElement } from 'react';
// Define types for Google Analytics
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}
export const initGoogleAnalytics = () => {
  try {
    // Create script element for Google Analytics
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-EEJRJXHJ0E';
    // Append the script to the document head
    document.head.appendChild(script);
    // Initialize the dataLayer
    window.dataLayer = window.dataLayer || [];
    // Define the gtag function
    function gtag(...args: any[]) {
      window.dataLayer.push(arguments);
    }
    // Set gtag on the window object
    window.gtag = gtag;
    // Initialize Google Analytics
    gtag('js', new Date());
    gtag('config', 'G-EEJRJXHJ0E');
    return () => {
      // Cleanup function
      document.head.removeChild(script);
    };
  } catch (error) {
    console.warn('Google Analytics failed to initialize:', error);
  }
};
// Track custom events if needed
export const trackEvent = (eventName: string, eventParams = {}) => {
  try {
    if (window.gtag) {
      window.gtag('event', eventName, eventParams);
    }
  } catch (error) {
    console.warn(`Failed to track event ${eventName}:`, error);
  }
};
export default {
  init: initGoogleAnalytics,
  trackEvent
};